import { Button, Tooltip } from '@mui/material';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onChange: (file: File) => void;
}

const ImageUploader = ({ onChange }: Props) => {
  const { t } = useTranslation();
  const [fontName, setFontName] = useState('');
  const inputRef = useRef<HTMLInputElement | null>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      onChange(file);
      setFontName(file.name);
    }
  };
  const handleClick = () => {
    inputRef.current?.click();
  };

  return (
    <>
      <Tooltip
        title={`${t('supported_font_file_formats_caption')}: .woff2,.woff,.ttf`}
        placement="bottom"
        arrow
      >
        <Button
          variant="contained"
          component="label"
          onClick={handleClick}
        >
          {fontName ? fontName.slice(0, 25) : t('upload_caption')}
        </Button>
      </Tooltip>
      <input
        hidden
        ref={inputRef}
        type="file"
        accept=".woff2,.woff,.ttf"
        onChange={handleChange}
      />
    </>
  );
};

export default ImageUploader;
